// extracted by mini-css-extract-plugin
export default {"container":"GameIcon_container__gtW4t","gameIcon":"GameIcon_gameIcon__WZoLk"};